// extracted by mini-css-extract-plugin
module.exports = {"whiteStyle":"e_LG","prefix":"e_MG","counter":"e_NG"};